import script from "./CadastroAfiliado.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroAfiliado.vue?vue&type=script&setup=true&lang=js"

import "./CadastroAfiliado.vue?vue&type=style&index=0&id=175f57f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175f57f7"]])

export default __exports__